import { render } from "./IndexHeroCarouselItem.vue?vue&type=template&id=5b3e63c8"
import script from "./IndexHeroCarouselItem.vue?vue&type=script&lang=js"
export * from "./IndexHeroCarouselItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__